import { useContext } from "react";
import { AuthContext } from "@/lib/auth";

export function useAuth() {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error("useAuth must be used within AuthProvider");
    }

    return context;
}

export async function getClaim(user) {
    if (!user) return null;

    const token = await user.getIdTokenResult(true);

    if (token.claims?.clinician) return "clinician";
    if (token.claims?.patient) return "patient";

    return null;
}
